import React, {Component} from "react";
import {AppRow} from "../components/components";
import {getPrefixedUrl} from "../../../utils/utils";
import {Link} from "@mui/material";
import {get} from "../../../helper/request";
import {error_manager} from "../../../helper/error_manager";
import {connect} from "react-redux";
import {updateMapState} from "../../../redux_actions/maps.state.action";

class HistogramTXTY extends Component {

	constructor(props) {
		super(props);

		this.isLogZipStatus = false;
	}

	componentDidMount() {
		!this.props.logZipStatus && this.fetchLogZipStatus();
	}

	fetchLogZipStatus = () => {
		if (this.isLogZipStatus)
			return;
		this.isLogZipStatus = true;
		get(getPrefixedUrl('/debug/log_status.json', this.props.slide))
			.then(logZipStatus => {
				this.updateMapState({logZipStatus});
			})
			.catch(() => {
				this.fetchLogZip()
			})
	}

	fetchLogZip = () => {
		get(`/api/download_log_zip/?id=${this.props.slide.id}`)
			.catch(error => error_manager("Failed to load zip file", error));
	}

	updateMapState = (state) => this.props.dispatch(updateMapState(this.props.activeMapId, state));

	render() {
		let histogramUrl = "/server/v3/tissue/" + this.props.slide.morphle_id + "/tiling/txty_histogram";
		let timeUrl = getPrefixedUrl(`meta/time_meta.json`, this.props.slide, true);
		let scanUrl = getPrefixedUrl(`meta/scan_params.json`, this.props.slide, true);
		let slideUrl = getPrefixedUrl(`meta/slide_meta.json`, this.props.slide, true);
		let take0DerivedCombSizeUrl = getPrefixedUrl(`meta/0_derived_comb_size.json`, this.props.slide, true);
		let fetchLogs = getPrefixedUrl(`debug/log.zip`, this.props.slide, true);

		return <div align={"right"}>
			<AppRow title={"TXTY Histogram"}>
				<Link style={{color: 'white'}} href={histogramUrl} target="_blank">Click Here</Link>
			</AppRow>
			<AppRow title={"Time Meta"}>
				<Link style={{color: 'white'}} href={timeUrl} target="_blank"> Click Here </Link>
			</AppRow>
			<AppRow title={"Scan Meta"}>
				<Link style={{color: 'white'}} href={scanUrl} target="_blank"> Click Here </Link>
			</AppRow>
			<AppRow title={"Slide Meta"}>
				<Link style={{color: 'white'}} href={slideUrl} target="_blank"> Click Here </Link>
			</AppRow>
			<AppRow title={"T0 Derived Comb"}>
				<Link style={{color: 'white'}} href={take0DerivedCombSizeUrl} target="_blank"> Click Here </Link>
			</AppRow>
			<AppRow title={"Logs Zip"}>
				<Link style={{color: 'white'}} href={fetchLogs} target="_blank">Click Here</Link>
			</AppRow>
			{this.props.slide.specimen_type === 'blood' ?
				<>
					<AppRow title={"Focus 100x Plot"}>
						<Link style={{color: 'white'}} target="_blank"
							  href={getPrefixedUrl(`res/focus_100x.html`, this.props.slide, true)}
						>Click Here</Link>
					</AppRow>
					<AppRow title={"Focus Drift Plot"}>
						<Link style={{color: 'white'}} target="_blank"
							  href={getPrefixedUrl(`res/focus_drift_plot.html`, this.props.slide, true)}
						>Click Here</Link>
					</AppRow>
					<AppRow title={"BloodScan Log"}>
						<Link style={{color: 'white'}} target="_blank"
							  href={getPrefixedUrl(`meta/blood_scan_log.json`, this.props.slide, true)}
						>Click Here</Link>
					</AppRow>
				</> : null}
		</div>
	}
}

const mapStateToProps = (state) => {
	let {activeMapId} = state.gammaStateReducer;
	let {logZipStatus} = state.mapsStateReducer[activeMapId];

	return {logZipStatus};
}

export default connect(mapStateToProps)(HistogramTXTY);
